// @flow
import axios from 'axios';
import { CONTENTFUL_PATH } from '../constants';

const NAMESPACE = '@@paidy.com/merchant_faq';

export const REQUEST_FAQ = `${NAMESPACE}/request_faq`;
export const RECEIVE_FAQ_SUCCESS = `${NAMESPACE}/receive_faq_success`;
export const RECEIVE_FAQ_FAIL = `${NAMESPACE}/receive_faq_fail`;

const initialState = {};

const reducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case REQUEST_FAQ: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case RECEIVE_FAQ_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        data: action.merchantFaq,
        updatedAt: action.updatedAt,
      };
    }
    default: {
      return state;
    }
  }
};

// merchant campaigns
const requestMerchantFAQ = () => {
  return {
    type: REQUEST_FAQ,
  };
};

const receiveMerchantFAQ = (data) => {
  return {
    type: RECEIVE_FAQ_SUCCESS,
    merchantFaq: data || [],
    updatedAt: Date.now(),
  };
};

const _fetchMerchantFAQ = () => {
  return (dispatch: Function) => {
    dispatch(requestMerchantFAQ());

    return axios
      .get(`${CONTENTFUL_PATH}merchant-faq.json`)
      .then((resp) => dispatch(receiveMerchantFAQ(resp.data)))
      .catch(console.error);
  };
};

export const fetchMerchantFAQ = () => {
  return (dispatch: Function) => dispatch(_fetchMerchantFAQ());
};

export default reducer;
